import {
	type BuilderCtx,
	CAP,
	type Collection,
	placeDistances,
} from './shared.ts'

// Place activities within a mile of where you are — true walking distance.
export const buildWalkingRow = ({
	activities,
	origin,
}: BuilderCtx): Collection | null => {
	if (!origin) return null
	return {
		key: 'walking',
		title: 'Nearby — walking',
		activities: placeDistances(activities, origin)
			.filter((p) => p.miles <= 1)
			.map((p) => p.activity)
			.slice(0, CAP),
		seeAll: { where: 'place', maxDistanceMiles: 1 },
	}
}
